// Component names
const NAME_BUTTON = 'BButton';
const NAME_BUTTON_CLOSE = 'BButtonClose';
const NAME_COL = 'BCol';
const NAME_DROPDOWN = 'BDropdown';
const NAME_DROPDOWN_DIVIDER = 'BDropdownDivider';
const NAME_DROPDOWN_FORM = 'BDropdownForm';
const NAME_DROPDOWN_GROUP = 'BDropdownGroup';
const NAME_DROPDOWN_HEADER = 'BDropdownHeader';
const NAME_DROPDOWN_ITEM = 'BDropdownItem';
const NAME_DROPDOWN_ITEM_BUTTON = 'BDropdownItemButton';
const NAME_DROPDOWN_TEXT = 'BDropdownText';
const NAME_FORM = 'BForm';
const NAME_FORM_CHECKBOX = 'BFormCheckbox';
const NAME_FORM_CHECKBOX_GROUP = 'BFormCheckboxGroup';
const NAME_FORM_GROUP = 'BFormGroup';
const NAME_FORM_INVALID_FEEDBACK = 'BFormInvalidFeedback';
const NAME_FORM_RADIO = 'BFormRadio';
const NAME_FORM_RADIO_GROUP = 'BFormRadioGroup';
const NAME_FORM_ROW = 'BFormRow';
const NAME_FORM_SELECT = 'BFormSelect';
const NAME_FORM_SELECT_OPTION = 'BFormSelectOption';
const NAME_FORM_SELECT_OPTION_GROUP = 'BFormSelectOptionGroup';
const NAME_FORM_TEXT = 'BFormText';
const NAME_FORM_TEXTAREA = 'BFormTextarea';
const NAME_FORM_VALID_FEEDBACK = 'BFormValidFeedback';
const NAME_LINK = 'BLink';
const NAME_MODAL = 'BModal';
const NAME_NAV = 'BNav';
const NAME_NAV_ITEM = 'BNavItem';
const NAME_POPOVER = 'BPopover';
const NAME_TAB = 'BTab';
const NAME_TABLE = 'BTable';
const NAME_TABLE_CELL = 'BTableCell';
const NAME_TABLE_LITE = 'BTableLite';
const NAME_TABLE_SIMPLE = 'BTableSimple';
const NAME_TABS = 'BTabs';
const NAME_TBODY = 'BTbody';
const NAME_TFOOT = 'BTfoot';
const NAME_TH = 'BTh';
const NAME_THEAD = 'BThead';
const NAME_TOAST = 'BToast';
const NAME_TOASTER = 'BToaster';
const NAME_TOOLTIP = 'BTooltip';
const NAME_TR = 'BTr';

// Helper component names
const NAME_FORM_BUTTON_LABEL_CONTROL = 'BVFormBtnLabelControl';
const NAME_FORM_RATING_STAR = 'BVFormRatingStar';
const NAME_POPOVER_HELPER = 'BVPopover';
const NAME_POPOVER_TEMPLATE = 'BVPopoverTemplate';
const NAME_POPPER = 'BVPopper';
const NAME_TAB_BUTTON_HELPER = 'BVTabButton';
const NAME_TOAST_POP = 'BVToastPop';
const NAME_TOOLTIP_HELPER = 'BVTooltip';
const NAME_TOOLTIP_TEMPLATE = 'BVTooltipTemplate';
const NAME_TRANSITION = 'BVTransition';
const NAME_TRANSPORTER = 'BVTransporter';
const NAME_TRANSPORTER_TARGET = 'BVTransporterTarget';

export { NAME_BUTTON, NAME_BUTTON_CLOSE, NAME_COL, NAME_DROPDOWN, NAME_DROPDOWN_DIVIDER, NAME_DROPDOWN_FORM, NAME_DROPDOWN_GROUP, NAME_DROPDOWN_HEADER, NAME_DROPDOWN_ITEM, NAME_DROPDOWN_ITEM_BUTTON, NAME_DROPDOWN_TEXT, NAME_FORM, NAME_FORM_BUTTON_LABEL_CONTROL, NAME_FORM_CHECKBOX, NAME_FORM_CHECKBOX_GROUP, NAME_FORM_GROUP, NAME_FORM_INVALID_FEEDBACK, NAME_FORM_RADIO, NAME_FORM_RADIO_GROUP, NAME_FORM_RATING_STAR, NAME_FORM_ROW, NAME_FORM_SELECT, NAME_FORM_SELECT_OPTION, NAME_FORM_SELECT_OPTION_GROUP, NAME_FORM_TEXT, NAME_FORM_TEXTAREA, NAME_FORM_VALID_FEEDBACK, NAME_LINK, NAME_MODAL, NAME_NAV, NAME_NAV_ITEM, NAME_POPOVER, NAME_POPOVER_HELPER, NAME_POPOVER_TEMPLATE, NAME_POPPER, NAME_TAB, NAME_TABLE, NAME_TABLE_CELL, NAME_TABLE_LITE, NAME_TABLE_SIMPLE, NAME_TABS, NAME_TAB_BUTTON_HELPER, NAME_TBODY, NAME_TFOOT, NAME_TH, NAME_THEAD, NAME_TOAST, NAME_TOASTER, NAME_TOAST_POP, NAME_TOOLTIP, NAME_TOOLTIP_HELPER, NAME_TOOLTIP_TEMPLATE, NAME_TR, NAME_TRANSITION, NAME_TRANSPORTER, NAME_TRANSPORTER_TARGET };
